
export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Authentic Products',
      description:
        'Every item in our store is verified authentic and sourced from trusted manufacturers. We never compromise on quality.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Expert Guidance',
      // Escape the apostrophe or use template literals to avoid breaking the string
      description:
        "Our knowledgeable staff brings years of experience and genuine passion. We're here to help you make informed decisions."
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Fair Pricing',
      description:
        'Premium quality doesn\'t have to mean premium prices. We offer competitive pricing on all our curated products.'
    },
    {
      icon: 'ri-store-3-line',
      title: 'Welcoming Atmosphere',
      description:
        "Step into a sophisticated, comfortable space designed for browsing and discovery. You're always welcome here."
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Exceptional Service',
      description:
        'Your satisfaction is our priority. We go above and beyond to ensure every visit exceeds your expectations.'
    },
    {
      icon: 'ri-map-pin-user-line',
      title: 'Local Community',
      description:
        "Proudly serving Eustis and Central Florida. We're your neighbors, and we're invested in our community's success."
    }
  ];

  return (
    <section className="py-24 bg-deep-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl text-white mb-4">
            Why Choose <span className="text-copper">High Standards</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Discover what sets us apart as Central Florida's premier smoke shop
            destination
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group text-center p-8 rounded-2xl bg-forest-green/50 hover:bg-forest-green transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-copper/10"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-copper/10 rounded-full group-hover:bg-copper/20 transition-colors duration-300">
                <i className={`${feature.icon} text-copper text-3xl`}></i>
              </div>

              {/* Title */}
              <h3 className="text-white font-semibold text-xl mb-4">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-300 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
